/* assets/size-guide.js
   Controls the size guide right-side drawer.
   - Opens without navigating away from the product page.
   - Dismissable by: tapping the overlay, the X button, or the mobile
     back gesture (via history state + popstate).
   - No layout shift: the trigger link's own box never changes size,
     and the panel is position:fixed so it doesn't affect page flow.
   - Reparented to <body> at runtime so it can't get trapped inside a
     transformed ancestor section (see initSizeGuide below). */

(function () {
  var HISTORY_KEY = 'size-guide-open';

  // The chart table now comes from the Page's rich-text content, so we
  // don't control its markup directly. This reads each <thead> <th> label
  // and copies it onto the matching <td> as data-label, which the CSS
  // card-view (below 480px) uses via td::before { content: attr(data-label) }.
  // Runs on every .size-guide-content on the page (the standalone page
  // template and/or the modal both have one).
  function decorateSizeTables() {
    document.querySelectorAll('.size-guide-content table').forEach(function (table) {
      var headerCells = table.querySelectorAll('thead th');
      if (!headerCells.length) return;

      var labels = Array.prototype.map.call(headerCells, function (th) {
        return th.textContent.trim();
      });

      table.querySelectorAll('tbody tr').forEach(function (row) {
        var cells = row.querySelectorAll('td');
        cells.forEach(function (cell, i) {
          if (labels[i]) cell.setAttribute('data-label', labels[i]);
        });
      });
    });
  }

  function initSizeGuide(root) {
    // Move the overlay+panel to be a direct child of <body>. Shopify
    // sections often apply a CSS transform to themselves (scroll/reveal
    // animations), and a transform on any ancestor changes the
    // containing block for position:fixed descendants — the panel would
    // then be clipped to that section's box instead of the real
    // viewport. Reparenting to <body> guarantees it's never trapped.
    if (root.parentNode !== document.body) {
      document.body.appendChild(root);
    }

    var overlay = root.querySelector('.size-guide-overlay');
    var panel = root.querySelector('.size-guide-panel');
    var closeBtn = root.querySelector('.size-guide-panel__close');
    var triggers = document.querySelectorAll('[data-size-guide-open]');

    if (!overlay || !panel || triggers.length === 0) return;

    var isOpen = false;

    function open() {
      if (isOpen) return;
      isOpen = true;
      overlay.classList.add('is-open');
      panel.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      panel.setAttribute('tabindex', '-1');
      panel.focus();

      // Push a history state so the mobile back gesture closes the
      // drawer instead of leaving the product page.
      history.pushState({ [HISTORY_KEY]: true }, '', location.href);
    }

    function close(fromPopState) {
      if (!isOpen) return;
      isOpen = false;
      overlay.classList.remove('is-open');
      panel.classList.remove('is-open');
      document.body.style.overflow = '';

      if (!fromPopState && history.state && history.state[HISTORY_KEY]) {
        history.back();
      }
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    });

    overlay.addEventListener('click', function () {
      close(false);
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        close(false);
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close(false);
    });

    window.addEventListener('popstate', function () {
      if (isOpen) close(true);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    decorateSizeTables();

    var root = document.getElementById('size-guide-modal-root');
    if (root) initSizeGuide(root);
  });
})();